import { Icon, Tooltip } from '@nazka/nazka.mapframe.components';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';

import './password-tooltip.css';

function PasswordTooltip() {
  return (
    <Tooltip
      id="password-help"
      className="password-tooltip"
      tooltip={(
        <div>
          <strong>Wachtwoordvereisten</strong>
          <br />
          Minstens 8 tekens
          <br />
          Bevat minstens 1 cijfer
          <br />
          Bevat minstens 1 speciaal teken
          <br />
          Bevat minstens 1 hoofdletter
          <br />
          Bevat minstens 1 kleine letter
        </div>
      )}
    >
      <Icon
        icon={faCircleInfo}
        size="14px"
        rootElProps={{ 'data-tooltip-id': 'password-help' }}
        className="password-tooltip__icon"
      />
    </Tooltip>
  );
}

export default PasswordTooltip;
